<template>
<v-card-text class="white--text">
  <VueMarkdown :source="explanation()"></VueMarkdown>
</v-card-text>
</template>

<script>
export default {
    name: "QueryExplanation",
    components: {
      VueMarkdown: () => import('vue-markdown')
    },
    data: () => ({
      conditionMap: {
        '=': "equal to",
        '!=': "not equal to",
        '>': "greater than",
        '>=': "greater than or equal to",
        '<': "less than",
        '<=': "less than or equal to",
        'LIKE': "is similar to",
      }
    }),
    props:{
      query: {
        required: true,
      },
      model: {
        required: true,
      },
    },
    computed:{

    },
    methods: {
      explanation() {
        return `Get ${this.model} ${this.where()} \n ${this.has()}`
      },
      where(){
        if(!this.query.where) return '';
        return '\nwhere ' + this.query.where.map((where, index) => {
          return `${index > 0 ? ">>**and** " : ''} ${where.key} is ${where.condition ? this.conditionMap[where.condition] : ''} \`${where.value}\``
        }).join("\n");
      },
      has(){
        if(!this.query.has) return ''
        return `where the ${this.model} have at least 1 ${this.query.has}`
      }
    }
}
</script>

<style scoped>

</style>
